import {createStore, applyMiddleware} from 'redux';
import {apiMiddleware} from 'redux-api-middleware';
import thunkMiddleware from 'redux-thunk';
import toggles from 'go/actions/api/toggles';
import createSagaMiddleware from 'redux-saga';
import {routerMiddleware} from 'react-router-redux';
import rootReducer from 'go/reducers';
import rootSaga from 'go/sagas/sagas';
import {history} from 'app-ui-componentlibrary/dist/common/constants';

import {composeWithDevTools} from 'remote-redux-devtools';

/*
    We define the construction of the redux store in this file, and initialize in index.js
*/
export const createGoStore = () => {
  const routingMiddleware = routerMiddleware(history);
  const sagaMiddleware = createSagaMiddleware();

  // https://www.npmjs.com/package/remote-redux-devtools
  const composeEnhancers = composeWithDevTools({port: 9011});

  const createStoreWithMiddleware = composeEnhancers(
    applyMiddleware(thunkMiddleware, apiMiddleware, routingMiddleware, sagaMiddleware)
  )(createStore);

  const startingReducer = rootReducer == undefined ? () => ({}) : rootReducer;

  const store = createStoreWithMiddleware(startingReducer);

  window.store = store;

  sagaMiddleware.run(rootSaga);
  store.dispatch(toggles.getAllToggles());

  return store;
};

const store = createGoStore();

export default store;
